module.exports = __webpack_public_path__ + "img/Brain.0a869b39.gif";